import React, { useState } from "react";
import { AtsRfqMstEdge } from "../../../quotation/queries/types";
import RFQAutocomplete from "./RFQAutocomplete";
import DataFetch from "../../../../../../../images/OpenIcon.svg";
import RfqDetails from "../RfqDetails";
import { ViewModalStyles } from "../../../../../../../styles/CustomModalStyles";
import { CustomModal } from "../../../../../../../utils/UtilFunctions";
import MRFAutocomplete from "./MRFAutocomplete";
import { AtsMrfMstEdge } from "../../../material/queries/types";
import MrfItems from "../../mrftopo/MrfItems";

export interface Props {
  onChange: (newValue: AtsMrfMstEdge | null) => void;
  value: AtsMrfMstEdge | null;
  autofocus?: boolean;
  onKeyDown?:
    | ((
        event: React.KeyboardEvent<HTMLDivElement> & {
          defaultMuiPrevented?: boolean;
        }
      ) => void)
    | undefined;
}
const MRFSelect = ({ onChange, value, autofocus, onKeyDown }: Props) => {
  const [rfqDetails, setRfqDetails] = useState(false);

  return (
    <>
      <MRFAutocomplete
        onChange={onChange}
        onKeyDown={onKeyDown}
        autofocus={autofocus}
        value={value}
      />
      <img
        src={DataFetch}
        alt=""
        className="data-fetch-icon"
        onClick={() => setRfqDetails(!rfqDetails)}
      />

      <CustomModal
        isOpen={rfqDetails}
        onRequestClose={() => setRfqDetails(false)}
        contentComponent={
          <MrfItems setModalFlag={setRfqDetails} onSelect={onChange} />
        }
        style={ViewModalStyles}
      />
    </>
  );
};

export default MRFSelect;
